module.exports = __webpack_public_path__ + "img/pdf.e10755e1.png";